import { CampoAlterado, DadosSolicitanteAtribuido } from "./types";
import { parseJsonSafely } from "../../../../../../../utility/jsonUtils";

export const mapearDadosSolicitanteAtribuido = (logs: any[]): DadosSolicitanteAtribuido | null => {
    const logProposta = logs.find((log: any) => log.entidade_nome === 'proposta');
    
    if (!logProposta) return null;

    const dadosAntes = parseJsonSafely(logProposta.dados_antes);
    const dadosDepois = parseJsonSafely(logProposta.dados_depois);
    const dadosExtra = parseJsonSafely(logProposta.dados_extra);

    const campos: CampoAlterado[] = [];
    const nomeEscritorio = dadosExtra?.nome_escritorio || undefined;

    if (dadosDepois && dadosDepois.id_escritorio_solicitante !== undefined) {
        const antes = dadosAntes?.id_escritorio_solicitante || null;
        const depois = dadosDepois.id_escritorio_solicitante;

        campos.push({
            campo: 'Solicitante',
            antes: antes ? `ES${antes}` : null,
            depois: nomeEscritorio || `ES${depois}`
        });
    }

    return {
        campos,
        nomeEscritorio
    };
};

